import {
  object,
  string,
  boolean,
  minLength,
  pipe,
  type InferInput
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export type UpdateSubPartnerFormValue = InferInput<
  typeof updateSubPartnerFormValueSchema
>

export const updateSubPartnerFormValueSchema = object({
  name: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)),
  enable: boolean(VALIDATION_MESSAGES.REQUIRED_ITEM)
})
